var map = {
	"./analysis.png": 3606,
	"./architecture.png": 7865,
	"./bg-coklat.png": 3980,
	"./booking.png": 6160,
	"./data analyst.png": 2561,
	"./data science.png": 4570,
	"./home (2).png": 8991,
	"./journalist.png": 6231,
	"./lawyer.png": 4257,
	"./logo.png": 6949,
	"./pilot.png": 7670,
	"./police.png": 7870,
	"./researcher.png": 2202,
	"./skills (1).png": 507,
	"./teacher.png": 5834,
	"./web developer.png": 8951,
	"./writer.png": 7973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;